import { Divider } from "@mui/material";

import useSessionMetadata from "@app/analytics/MeetingReport/hooks/useSessionMetadata";
import { useMeetingReportContext } from "@app/analytics/MeetingReport/providers/MeetingReportContext";
import useEditStore from "@app/analytics/MeetingReport/stores/edits";
import { DisabledOverlay } from "@app/analytics/MeetingReport/styles";
import Transcript from "@app/analytics/MeetingReport/Transcript";
import DeleteTurnConfirmationModal from "@app/analytics/MeetingReport/Transcript/DeleteTurnConfirmationModal";

import KeywordsAndSpeakers from "./KeywordsAndSpeakers";

const MeetingReportRecapTranscript = () => {
  const { mainScrollContainer } = useMeetingReportContext();
  const {
    data: { isRestrictedReport, shouldUpsellTranscriptEntities },
  } = useSessionMetadata();

  const hasActiveParagraph = useEditStore(
    (state) => state.transcript.activeParagraph != null
  );

  return (
    <>
      <KeywordsAndSpeakers shouldUpsell={shouldUpsellTranscriptEntities} />
      <Divider sx={{ mt: 2 }} />
      <Transcript
        context={{ section: "main", tab: "recap" }}
        isRestrictedReport={isRestrictedReport}
        scrollContainer={mainScrollContainer}
      />
      <DisabledOverlay
        variant="light"
        className={hasActiveParagraph ? undefined : "hidden"}
      />
      <DeleteTurnConfirmationModal />
    </>
  );
};

export default MeetingReportRecapTranscript;
